import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { ApiError, api } from "../lib/api";
import { useSession } from "../lib/session";

export default function ForgotPassword() {
  const { settings } = useSession();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch (cause) {
      setError(cause instanceof ApiError ? cause.message : "The request could not be sent.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      heading="Reset your password"
      blurb="Give us the address on your account and we will send a link that lasts one hour."
    >
      {sent ? (
        <>
          <p className="form-note" role="status">
            If that address has an account, a reset link is on its way. The link lasts an hour.
            Your authenticator app stays as it is, so you will still need a code to sign in.
          </p>
          {settings.emailEnabled ? null : (
            <p className="hint">
              This installation has no email provider configured. An administrator can generate a
              reset link for you from the admin area.
            </p>
          )}
          <div className="auth-alt">
            <Link to="/sign-in">Back to sign in</Link>
          </div>
        </>
      ) : (
        <>
          <form className="stack" onSubmit={onSubmit} noValidate>
            {error ? (
              <p className="form-error" role="alert">
                {error}
              </p>
            ) : null}
            <div className="field">
              <label htmlFor="email">Email address</label>
              <input
                id="email"
                className="input"
                type="email"
                name="email"
                autoComplete="username"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
              {busy ? <span className="spinner" /> : null}
              {busy ? "Sending…" : "Send the reset link"}
            </button>
          </form>
          <div className="auth-alt">
            <Link to="/sign-in">Back to sign in</Link>
          </div>
        </>
      )}
    </AuthLayout>
  );
}
